export const USN_THRESHOLD_20 = 20000000;
export const USN_THRESHOLD_272 = 272500000;
export const USN_THRESHOLD_490 = 490500000;
export const PSN_THRESHOLD_20 = 20000000;
export const AUSN_THRESHOLD_60 = 60000000;
